import React from 'react';

import { Box, ButtonBase, CircularProgress } from '@mui/material';

import clsx from 'clsx';

import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const BaseActionButton = (props: IBaseActionButtonProps) => {
  const {
    children,
    onClick,
    styles,
    isActive = false,
    disabled = false,
    loading = false,
    ...buttonProps
  } = props;

  const { classes } = useStyles(styles);
  const isDisabled = disabled || loading;

  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <ButtonBase
        aria-label="edit"
        disabled={isDisabled}
        className={clsx(classes.iconButton, {
          [classes.iconActiveButton]: isActive,
          [classes.disabledButton]: isDisabled,
        })}
        onClick={loading ? undefined : onClick}
        {...buttonProps}>
        {children}
      </ButtonBase>
      {loading && (
        <CircularProgress
          size={20}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            marginLeft: '-10px',
            marginTop: '-10px',
          }}
        />
      )}
    </Box>
  );
};

export default BaseActionButton;
